import { TableContainer, TableRow } from "@mui/material";
import { styled } from "@mui/material/styles";
import TableCell from "@mui/material/TableCell";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 600,
  fontFamily: "Urbane-Light",
  backgroundColor: "#ECF1FF",
  fontSize: "12px",
  lineHeight: "15px",
  color: "#202020",
  padding: "1rem",
  borderBottom: "1px solid #AED9FF",
  whiteSpace: "nowrap",
  textWrap: "nowrap",
  textTransform: "capitalize",
  textAlign: "center",
  border: "1px solid #ddd",
  position: "sticky",
  top: -1,
  zIndex: 1,
  wordWrap: "break-word", // Ensure long words break if necessary
  whiteSpace: "pre-line", // Preserve line breaks and wrap text
  tableLayout: "auto",
  
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  margin: "auto",
  mt: 3,
  maxHeight: "calc(100vh - 100px)",
  overflowY: "auto",
}));
export const ReportsStyledTableContainer = styled(TableContainer)(({ theme }) => ({
  width: "100%",
  margin: "auto",
  mt: 3,
  maxHeight: "calc(100vh - 200px)",
  overflowY: "auto",
}));

export const StyledTableRow = styled(TableCell)(
  ({ align = "left", theme }) => ({
    fontWeight: 400,
    fontFamily: "Urbane-Light",
    fontSize: "12px",
    lineHeight: "14px",
    color: "#202020",
    padding: "10px",
    textAlign: align,
    border: "1px solid #ddd",
    // textTransform:"capitalize"
  })
);

const NoDataRow = styled(TableCell)(({ theme }) => ({
  fontWeight: 400,
  fontFamily: "Roboto",
  fontSize: "20px",
  lineHeight: "38px",
  color: "grey",
  padding: "15px",
}));

export const NoDataFoundRow = ({
  colSpan,
  message = "No Data Found",
  ...props
}) => {
  return (
    <TableRow>
      <NoDataRow
        colSpan={colSpan}
        align="center"
        sx={{ fontFamily: "Urbane-Light", fontSize: "16px" }}
        {...props}
      >
        {message}
      </NoDataRow>
    </TableRow>
  );
};

import { Box, Typography } from "@mui/material";
export const NoDataFound = ({ message = "No Data Found" }) => {
  return (
    <Box
      sx={{
        mt: 8,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        textAlign: "center",
        fontSize: "25px",
        color: "grey",
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};
